import $ from 'jquery';
import 'jquery-mask-plugin';

import './accordion';
import './enabled-button';
import './back-button';
import './bambuser';
import './countdown';
import './focus-to';
import './dropdown';
import './toggle-dropdown';
import './toggle-display';
import './toggle-reveal';
import './toggle-elements';
import './category-menu';
import './drawer';
import './toggle-text';
import './truncate';
import './close-banner';
import './product-size-change';
import './product-size-click';
import './product-add-to-bag';
import './product-color-change';
import './product-oos';
import './product-zoom';
import './horizontal-scroll';
import ImageCarousel from './image-carousel';
import './tabs';
import './rating-scale/rating-scale';
import './ab-controls';
import './impressions-controls';
// import updateNotifyMe from './notify-me-update';
import './modal';
import './track-video';
import './vanish/vanish';
import './slick-slider';
import './switch-class';
import './rich-nav';
import lazyload from './lazyload';
import './lazyload-image';
import './toggle-change';
import './shipping-options-from-bag';
import './copy-clipboard';
import './char-counter';
import './cc-mask';
import './progressiveButton';
import './progress-ring';
import './counter';
import './add-to-calendar';
import './visual-nav';
import './swipe-view';
import './cookies-banner';
import './side-panel';
import './abtest/follow-shops';
import './image-upload';
import './sticky-nav';
import './instruction-overlay';

import noFocus from './no-focus';
import '../modules/abtest/model-switch';

// lazyload
function setupLazyLoad() {
  lazyload({
    slideshowSettings: {
      arrows: false,
      infinite: false,
      mobileFirst: true,
      slidesToShow: 2.5,
      slidesToScroll: 2,
      lazyLoad: 'ondemand',
      accessibility: false,
    },
  });
}
function filterSetup() {
  const $pageHeaderOverlay = $('.js-page-header-overlay');
  const $pageHeaderTitle = $('.page-header__title');
  $pageHeaderOverlay.on('click', () => {
    $pageHeaderTitle.click();
  });
}

window.resetLazyLoad = function resetLazyLoadFunc() {
  setupLazyLoad();
  $('.js-lazyload-slick').removeClass('js-lazyload-slick');
  $('.js-horizontal-scroll').horizontalScroll();
};

window.setupImageCarousel = () => {
  // Image Carousels
  const IMAGE_CAROUSEL_SELECTOR = '.image-carousel';
  const PRODUCT_ZOOM_SELECTOR = `${IMAGE_CAROUSEL_SELECTOR}--product-zoom`;
  const $imageCarousel = $(IMAGE_CAROUSEL_SELECTOR);

  const videos = [];
  $imageCarousel.on('init', () => {
    $('.image-carousel__item').each((index, val) => {
      const hasVideo = $(val).hasClass('image-carousel__item--vid');
      if (hasVideo) {
        // has video
        const vidIndex = $(val).index();
        $('.image-carousel__dots li').eq(vidIndex).children('.image-carousel__dot-button').addClass('image-carousel__dot-button--vid');
        const vidSrc = $('.image-carousel--product-zoom li').eq(vidIndex).find('source').attr('src');
        videos.push(vidSrc);
      }
    });
  });

  $imageCarousel
    .filter(`:not(${PRODUCT_ZOOM_SELECTOR})`)
    .imageCarousel();

  $imageCarousel
    .filter(PRODUCT_ZOOM_SELECTOR)
    .each(function setupZoomCarousel() {
      const carousel = new ImageCarousel(this);
      $(this).productZoom({
        slideFunc: carousel.setSlideNumber.bind(carousel),
        beforeUnmount: carousel.transitionSlide.bind(carousel),
        targetSelector: 'img,video',
        videos,
      });
    });
};

window.setUpProductHandlers = () => {
  const $product = $('.product');
  $product.find('.product__size select:not(.js-products-as-sizes), .product__size input')
    .sizeChange()
    .trigger('change');

  const sizeInputs = $product.find('#pdp-size-options input').pdpSizeClick();
  // in order to display the preorder notification info
  if (sizeInputs.length === 1 && $(sizeInputs[0]).data('preorder')) {
    sizeInputs.trigger('click');
  }

  $product.find('.product__color select').colorChange();
  $product.find('.js-products-as-sizes').colorChange();
  $product
    .find('form')
    .filter('[data-open="product-added-confirmation"]')
    .addToBag();
  $product.find('.product-oos').oosProduct();
};


$(document).ready(() => {
  $('.js-enabled-button').enabledButton();
  filterSetup();
  noFocus();
  setupLazyLoad();
  $('.js-horizontal-scroll').horizontalScroll();
  $('.js-lazyload-image').lazyLoadImage();
  $('#shippingTableFromBag').shippingOptionsFromBag();
  $('.js-accordion').accordion();
  // issue with sizeguide, remove once cleaned up
  $('.js-accordion-nav').accordion();
  $('.js-bambuser').bambuser();
  $('.js-tabs').tabs();
  // UX-17870
  $('.js-order-tabs').tabs({
    tab: '.pill-button--white',
    tabContent: '.tabs__content',
    tabContentActive: 'tabs__content--active',
    tabActive: 'pill-button--black',
  });
  $('.js-toggle-text').toggleText();
  $('.js-toggle-elements').toggleElements();
  $('.js-toggle-dropdown').toggleDropdown();
  $('.js-toggle-reveal').toggleReveal();
  $('.js-progress-ring').progressRing();
  $('.js-modal').modal();
  $('.js-modal-utility').modal({ setA11yOnly: true });
  $('.js-track-video').trackVideo();
  $('[data-truncate]').truncate();
  $('.back-button').backButton();
  $('.js-switch-class').switchClass();
  $('.js-mask-cc').ccMask();
  $('.js-progressive-button').progressiveButton();
  $('.js-toggle-display').toggleDisplay();
  $('.js-counter').counter();
  $('.js-add-to-calendar').addToCalendar();
  $('.js-upload-form').imageUploader();
  $('.js-nav-switch-class').switchClass({
    isActive: () => {
      // Close category menu
      $.toggleDropdown.close();
      $.categoryMenu.close();
      $(document).trigger('removeConstrainPage');
    },
  });
  $('.js-countdown').countdown();
  $('#js-rich-nav').richNav();
  $('.js-toggle-change').toggleChange();
  $('.js-char-counter').charCounter();
  $('.js-close-banner').closeBanner();
  $('.js-category-menu').categoryMenu();
  $('.js-swipe-view').swipeView();
  $('.js-lazyload-slick').removeClass('js-lazyload-slick');
  $('.js-sticky-nav').stickyNav();
  $('.js-focus-to').focusTo();
  // const used for rtl slick
  const language = $('html').attr('lang');
  const rtlBool = language === 'ar';
  $('.js-featured-slides').slick({
    arrows: false,
    infinite: false,
    mobileFirst: true,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    lazyLoad: 'progressive',
    accessibility: false,
    touchThreshold: 20,
  });
  $('#js-featured-shops-slider').slick({
    arrows: false,
    infinite: false,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'progressive',
    accessibility: false,
    dots: true,
    touchThreshold: 20,
  });
  $('.js-carousel-single-product').slick({ // Used for landing pages - UX-14577
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: '.js-carousel__nav-next-single',
    prevArrow: '.js-carousel__nav-prev-single',
    touchThreshold: 20,
  });

  // drawer animation of dynamic content in buy now modal on PDP
  $('.js-drawer-class').drawer();
  // Global Banner slider
  const bannerSlideshow = $('.js-slideshow');
  if (bannerSlideshow.children('.banner--slider-list__item').length > 1) {
    if (language === 'ar') {
      bannerSlideshow.attr('dir', 'rtl');
    }
    bannerSlideshow.slick({
      autoplay: true,
      autoplaySpeed: 6000,
      prevArrow: '.banner__slick-prev',
      nextArrow: '.banner__slick-next',
      rtl: rtlBool,
      touchThreshold: 20,
    });
    $('.banner__slick-next, .banner__slick-prev').on('click', () => {
      bannerSlideshow.slick('slickPause');
    });
  } else {
    $('.banner__slick-next, .banner__slick-prev').hide();
    $('.banner--slider-list').show();
  }

  // Voyages slider
  $('.js-voyages-package').each(function voyagesPackage() {
    const $voyagesSelf = $(this);
    const $voyagersSlideshow = $voyagesSelf.find('.js-voyagers-slideshow');
    $voyagersSlideshow.slick({
      lazyLoad: 'ondemand',
      arrows: false,
      infinite: false,
      dots: true,
      touchThreshold: 20,
    });
  });
  const $activeLink = $('.pill-button--black');
  // Check if the element exists
  const $scrollTarget = $('.js-scroll-target');

  // Set the scroll position immediately without animation
  if ($activeLink.length) {
    // Get the position of the active link relative to the scroll container
    const targetOffsetLeft = $activeLink.offset().left;
    const scrollContainerOffsetLeft = $scrollTarget.offset().left + 16;
    // Find the scrollable container
    $scrollTarget.scrollLeft(targetOffsetLeft - scrollContainerOffsetLeft);
    // Focus on the active link immediately after adjusting the scroll
  }
  // input masking
  if ($('.js-mask-tel-us').length) {
    $('.js-mask-tel-us').mask('+1(000) 000-0000');
  }
  if ($('.js-mask-date').length) {
    $('.js-mask-date').mask('00/00/0000');
  }
  if ($('.js-mask-mx').length) {
    $('.js-mask-mx').mask('+52#000000000');
  }

  $('.js-copy-clipboard').copyToClipboard();
  window.setUpProductHandlers();
  window.setupImageCarousel();

  // const notifyMeClass = 'notify-me';

  // $(`.${notifyMeClass}`).find('.product__size select, .product__size input')
  //   .sizeChange({ wrapBlockClass: notifyMeClass, update: updateNotifyMe })
  //   .trigger('change');

  $('.js-rating-scale').ratingScale({
    titleSelector: '.form-section__title',
  });

  $('.js-model-switch').modelSwitch();

  if ($('.multiple-models').length) {
    $('.multiple-models__button').on('click', () => {
      // NOTE: URL for `url` will need to be changed
      $.modal({
        url: './dialog/multiple-models-modal.html',
        type: 'toast',
        triggerOpen: true,
        closeButton: true,
        onComplete() {
          $('.js-tabs-size-guide').tabs({
            tab: '.tabs-size-guide__link',
            tabActive: 'tabs-size-guide__link--active',
            tabContentActive: 'sizeguide-tab-content--active',
          });
          $('.js-model-switch').modelSwitch();
        },
      });
    });
  }

  //  UX-19302 BE might use their own logic for this
  $('.js-text-switch-trigger').on('click', function () {
    const isActive = $(this).data('is-active');
    // Get custom text from data attributes, with fallbacks
    const activeText = $(this).data('active-text');
    const inactiveText = $(this).data('inactive-text');

    if (!isActive) {
      // Change to active state
      $(this).addClass('is-active');
      if ($(this).hasClass('js-action-button-target')) {
        $(this).removeClass('action-button--dark');
      } else {
        $(this).removeClass('pill-button--black');
        $(this).addClass('pill-button--white-blk-stroke');
      }
      $(this).find('.js-toggle-icon-heart').addClass('u-hide');
      $(this).find('.js-toggle-icon').removeClass('u-hide');
      $(this).find('.js-button-text-target').text(activeText);
      $(this).data('is-active', true);
    } else {
      // Revert back to inactive state
      $(this).removeClass('is-active');
      $(this).addClass('pill-button--black');
      $(this).removeClass('pill-button--white-blk-stroke');
      $(this).find('.js-toggle-icon').addClass('u-hide');
      $(this).find('.js-toggle-icon-heart').removeClass('u-hide');
      $(this).find('.js-button-text-target').text(inactiveText);
      $(this).data('is-active', false);
    }
  });

  // ai-chat window AB 568
  $(document.getElementsByClassName('vanish')).vanish();
  $('.js-ab-controls').abControls(); // Ab Testing Controls for previewing on testing servers
  $('.js-impressions-controls').impressionsControls();
  $('.js-cookies-banner-toggle').cookiesBanner();
  $('.js-dropdown').dropdown();
});
$(window).on('load', () => {
  // get width of the nav links for overflow purposes
  let totalNavLinksWidth = 0;
  const navBar = $('.nav.nav--justified');
  const navBarWrapper = $('ul.nav__wrapper.container');
  const navBarInViewWidth = navBarWrapper.width();
  const navLinks = $('.nav.nav--justified .nav__wrapper .nav__item');
  navLinks.each((i, el) => {
    totalNavLinksWidth += parseInt($(el).outerWidth(), 10);
  });
  if (totalNavLinksWidth > navBarInViewWidth) {
    navBar.addClass('nav__overflow');
  }
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/modules.js